(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sc-newsletter-popup"] && !Shopify.designMode) return;
  try {
    
  class ScNewsletterPopup extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('dialog');
      if (!this.dialog) return;

      this.storageKey = this.dataset.storageKey || 'sc-nlpop';
      this.designMode = Boolean(window.Shopify && window.Shopify.designMode);

      this.dialog.addEventListener('close', () => this.remember());
      this.querySelectorAll('[data-sc-nlpop-close]').forEach((button) => {
        button.addEventListener('click', () => this.dialog.close());
      });
      this.dialog.addEventListener('click', (event) => {
        if (event.target === this.dialog) this.dialog.close();
      });

      // hCaptcha cuelga su reto de imagenes del <body>. Con el popup abierto en modal, todo lo
      // que queda fuera es inerte y se pinta por debajo: si salta el reto, no se puede resolver.
      // Al enviar, el popup pasa a no modal (sigue en su sitio) y el reto queda por encima.
      const form = this.dialog.querySelector('form');
      if (form) form.addEventListener('submit', () => this.liberarParaCaptcha());

      const copyButton = this.querySelector('[data-sc-nlpop-copy]');
      if (copyButton) copyButton.addEventListener('click', () => this.copyCode(copyButton));

      // Shopify recarga la pagina tras el alta: si el formulario volvio con exito,
      // el popup se reabre solo para entregar el codigo.
      if (this.querySelector('[data-sc-nlpop-success]')) {
        this.open();
        return;
      }

      if (this.designMode) {
        document.addEventListener('shopify:section:select', (event) => {
          if (this.closest(`#shopify-section-${event.detail.sectionId}`)) this.open();
        });
        document.addEventListener('shopify:section:deselect', () => {
          if (this.dialog.open) this.dialog.close();
        });
        return;
      }

      if (this.dataset.disabled === 'true' || this.isSnoozed()) return;

      this.scheduled = false;
      const delay = Number.parseInt(this.dataset.delay, 10);
      if (Number.isFinite(delay) && delay >= 0) {
        this.timer = window.setTimeout(() => this.open(), delay * 1000);
      }

      const threshold = Number.parseInt(this.dataset.scroll, 10);
      if (Number.isFinite(threshold) && threshold > 0) {
        this.onScroll = () => {
          const scrollable = document.documentElement.scrollHeight - window.innerHeight;
          if (scrollable <= 0) return;
          if ((window.scrollY / scrollable) * 100 >= threshold) this.open();
        };
        window.addEventListener('scroll', this.onScroll, { passive: true });
      }
    }

    disconnectedCallback() {
      window.clearTimeout(this.timer);
      window.clearTimeout(this.bannerTimer);
      if (this.onScroll) window.removeEventListener('scroll', this.onScroll);
    }

    open() {
      if (this.scheduled || !this.dialog || this.dialog.open) return;
      this.scheduled = true;
      window.clearTimeout(this.timer);
      if (this.onScroll) window.removeEventListener('scroll', this.onScroll);
      this.showWhenFree();
    }

    // Dos modales a la vez es una mala primera visita: si el aviso de cookies sigue
    // en pantalla, el popup espera a que el visitante lo resuelva.
    showWhenFree(attempt = 0) {
      if (attempt < 60 && (this.consentBannerVisible() || this.otherDialogOpen())) {
        this.bannerTimer = window.setTimeout(() => this.showWhenFree(attempt + 1), 1000);
        return;
      }
      if (this.dialog.open) return;
      this.dialog.showModal();
      const success = this.querySelector('[data-sc-nlpop-success]');
      if (success) success.focus();
    }

    liberarParaCaptcha() {
      if (!this.dialog.open || !this.dialog.matches(':modal')) return;
      this.dialog.close();
      this.dialog.show();
    }

    // Tampoco encima del cajon del carrito, del buscador ni del menu movil: si el
    // visitante ya tiene algo abierto, el popup espera su turno.
    otherDialogOpen() {
      for (const dialog of document.querySelectorAll('dialog[open]')) {
        if (dialog !== this.dialog) return true;
      }
      return false;
    }

    // El aviso de cookies de Shopify va en position:fixed, asi que su offsetParent
    // siempre es null: hay que medirlo, no preguntar por el padre.
    consentBannerVisible() {
      const banner = document.querySelector('#shopify-pc__banner');
      if (!banner) return false;
      const rect = banner.getBoundingClientRect();
      if (rect.width === 0 || rect.height === 0) return false;
      const estilo = window.getComputedStyle(banner);
      return estilo.display !== 'none' && estilo.visibility !== 'hidden' && estilo.opacity !== '0';
    }

    isSnoozed() {
      const days = Number.parseInt(this.dataset.frequency, 10);
      if (!Number.isFinite(days) || days <= 0) return false;
      try {
        const seen = Number.parseInt(window.localStorage.getItem(this.storageKey), 10);
        if (!Number.isFinite(seen)) return false;
        return Date.now() - seen < days * 86400000;
      } catch (error) {
        return false;
      }
    }

    remember() {
      if (this.designMode) return;
      try {
        window.localStorage.setItem(this.storageKey, String(Date.now()));
      } catch (error) {
        /* almacenamiento no disponible: el popup volvera a salir en la proxima visita */
      }
    }

    copyCode(button) {
      const code = this.querySelector('[data-sc-nlpop-code]');
      if (!code || !navigator.clipboard) return;
      navigator.clipboard.writeText(code.textContent.trim()).then(() => {
        button.textContent = button.dataset.labelCopied;
        window.setTimeout(() => {
          button.textContent = button.dataset.labelCopy;
        }, 2400);
      });
    }
  }

  if (!customElements.get('sc-newsletter-popup')) {
    customElements.define('sc-newsletter-popup', ScNewsletterPopup);
  }

  } catch(e) { console.error(e); }
})();
})();
